<template>
  <v-select
    v-if="table"
    filled
    :hide-details="!isRequired"
    :label="title"
    :items="fields"
    item-text="name"
    item-value="name"
    :rules="rules"
    :value="value"
    @input="onChange"
    clearable
  ></v-select>
</template>

<script>
import ui from "../../../services/ui";
import helpers from "../../../helpers/helpers";
import constants from "../../../helpers/constants";

export default {
  name: "ServerFieldPicker",

  props: ["title", "isRequired", "value", "table"],

  watch: {
    table() {
      this.refresh();
    },
  },

  data() {
    return {
      fields: [],
      rules: this.isRequired ? [ui.requiredRule] : [],
    };
  },

  mounted() {
    this.refresh();
  },

  methods: {
    async refresh() {
      if (this.table) {
        var fs = await helpers.getTableFields(this.table);
        fs.push({ dataType: "int", name: "_id", title: "_id" });
        this.fields = await helpers.getTableFields(this.table);
      } else {
        this.fields = [];
      }
    },
    getDataType(name) {
      for (let i = 0; i < this.fields.length; i++) {
        const f = this.fields[i];
        if (f.name == name) return f.dataType;
      }

      return constants.DATA_TYPE_TEXT;
    },
    onChange(e) {
      if (e) {
        this.$emit("input", e);
        this.$emit("type-change", this.getDataType(e));
      } else {
        this.$emit("input", null);
        this.$emit("type-change", null);
      }
    },
  },
};
</script>
